import { useAppSelector } from '../app/hooks/store-hooks';
import { FilterGroupType } from '../types/filter-group';

export default function useFilterGroup(type: FilterGroupType | undefined) {
    if (type === undefined) {
        return [];
    }
    return useAppSelector((x) => x.filterGroups.groups[type]);
}
